import { ArrowDown } from "@/icons";
import clsx from "clsx";
import "./CategoryHeader.scss";

type CategoryHeaderProps = {
  className?: string;
  titleClassName?: string;
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  selectedStructures?: string[];
  hasBorder?: boolean;
};
export const CategoryHeader = ({
  className = "",
  title,
  isOpen,
  onToggle,
  selectedStructures,
  titleClassName = "fw-semibold fs-6 text-primary pb-x16 px-x24",
  hasBorder = true,
}: CategoryHeaderProps) => {
  return (
    <button
      className={clsx(
        hasBorder && "ui-has-border-bottom",
        "ui-btn-accordion-filter",
        className,
      )}
      type="button"
      onClick={onToggle}
    >
      <h1 className={clsx(titleClassName)}>
        {title} {selectedStructures ? `(${selectedStructures.length})` : ""}
      </h1>
      <div className={"px-x24"}>
        <ArrowDown
          color="primary"
          className={clsx("ui-arrow ", { "ui-expanded": isOpen })}
        />
      </div>
    </button>
  );
};
